import styles from './SidebarItem.module.scss'


type SidebarItemProps = {
  isActive?: boolean
  icon: string
  title: string
  isOpen: boolean
  handler: () => void
}


export const SidebarItem = ({
  isActive,
  isOpen,
  handler,
  icon,
  title
}: SidebarItemProps) => {
  return (
    <button
      className={`
        ${styles.sidebarItem}
        ${isActive && styles.active}
        ${isOpen && styles.open}
      `}
      onClick={handler}
    >
      <img
        className={styles.icon}
        src={icon}
        alt='sidebarItem'
      />
      <p>
        {title}
      </p>
    </button>
  )
}
